<template>
<div class="template visitorsList">
  <el-form :inline="true">
    <el-form-item :label="$t('im.common.startTime')">
      <el-date-picker
        v-model="startTime"
        type="datetime"
        :placeholder="$t('im.common.placeholderStartTime')">
      </el-date-picker>
    </el-form-item>
    <el-form-item :label="$t('im.common.endTime')">
      <el-date-picker
        v-model="endTime"
        type="datetime"
        :placeholder="$t('im.common.placeholderEndTime')">
      </el-date-picker>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="searchVisitorsList">{{$t('common.search')}}</el-button>
      <el-button @click="resetRule">{{$t('common.reset')}}</el-button>
    </el-form-item>
  </el-form>
  <el-table v-if="visitorsData" :data="visitorsData" style="width: 100%" border>
    <el-table-column :prop="item.id" :label="item.name" v-for="item in visitorsNav" :show-overflow-tooltip="true"></el-table-column>
  </el-table>
  <div class="block flexEnd" v-if="totalNum>0">
    <el-pagination
      background
      @size-change="pageSizeChange"
      @current-change="currentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40,50]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalNum">
    </el-pagination>
  </div>
</div>
</template>
<script>
  require('@/styles/IM/template.css');
  import Util from '@/utils/IM/tradeDataUtil'
  import apiChatSystem from "@/api/im/chatSystem"
  import { localRead} from '@/utils/tools'
  export default {
    name: 'visitorsList',
    data() {
      return {
        util: Util,
        userInfo: JSON.parse(localRead('sys_userInfo_IM')),
        businessGroupData: JSON.parse(localRead('sys_userInfo_IM')).businessIdUser,
        bizCodes:[],//业务编码Code组
        langList: JSON.parse(localRead('locale_IM')),  //语言列表  //业务编码列表
        currentPage: 1,   //当前页
        pageSize: 10, //当前页条数数
        totalNum: 0,  //当前资源条数
        startTime: '',//开始时间
        endTime:'',//结束时间
        visitorsNav: [
          { name: window.$t('im.common.bizCodeName'), id: 'bizCodeName' },
          { name: window.$t('im.common.visitorsID'), id: 'customerId' },
          { name: window.$t('im.common.visitorsName'), id: 'name' },
          { name: window.$t('im.common.accountNum'), id: 'account' },
          { name: window.$t('im.common.visitorsWay'), id: 'clientName' },
          { name: window.$t('im.common.visitorsSource'), id: 'userSource' },
          { name: window.$t('im.common.clientDetail'), id: 'clientDetail' },
          { name: window.$t('im.common.visitorsNum'), id:"accessNum"},
          { name: window.$t('im.common.visitorsIp'), id: 'userIp' },
          { name: window.$t('im.common.address'), id: 'userAddress' },
          { name: window.$t('im.common.lastAccessAddress'), id: 'lastAccessAddress' },
          { name: window.$t('im.common.locale'), id: 'localeName' },
          { name: window.$t('im.common.updateDate'), id: 'updateDate' },
        ],//访客列表标题
        visitorsData: [],//访客列表
        clientTypeData: [
          { name: window.$t('im.common.mobile'), id: 0 },
          { name: window.$t('im.common.pc'), id: 1 },
          { name: window.$t('im.common.app'), id: 2 }
        ],//访客方式
      }
    },
    methods:{
      /*初始化业务组*/
      initBusinessGroup() {
        let data = []
        if (this.businessGroupData.length > 0) {
          for (const i in this.businessGroupData) {
            data.push(this.businessGroupData[i].code)
          }
          this.bizCodes = data
        }
      },
      /*刷选业务列表*/
      brushBusinessGroup(obj) {
        if (obj.userType == 0||Util.isEmpty(obj.userType)) obj.account = ''
        for (const i in this.clientTypeData) {
          if (obj.clientType == this.clientTypeData[i].id) {
            obj.clientName = this.clientTypeData[i].name
          }
        }
        for (const j in this.langList) {
          if (this.langList[j].id == obj.locale) {
            obj.localeName = this.langList[j].name
          }
        }
        for (const j in this.businessGroupData) {
          if (this.businessGroupData[j].code == obj.bizCode) {
            obj.bizCodeName = this.businessGroupData[j].name
          }
        }
        return obj
      },
      /*获取访客列表数据*/
      getVisitorsList(data) {
        apiChatSystem.queryBizUserListPage(data).then(res => {
          if (res.code == 0) {
            if (res.result.list) {
              let newData = JSON.parse(JSON.stringify(res.result.list))
              for (const i in newData) {
                this.brushBusinessGroup(newData[i])
              }
              this.visitorsData = newData
            } else {
              this.visitorsData = []
            }
            this.totalNum = res.result.total
          }
        })
      },
      /*初始化访客列表*/
      initVisitorsList(){
        let data = {
          companyId: this.userInfo.companyId,
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          bizCodes: this.bizCodes
        }
        this.getVisitorsList(data)
      },
      /*切换访客列表分页条数*/
      pageSizeChange(val) {
        this.pageSize = val
        let data = {
          queryStartTime : Util.isNotEmpty(this.startTime)?new Date(this.startTime).format("Y-MM-dd hh:mm:ss"):"",
          queryEndTime: Util.isNotEmpty(this.endTime)?new Date(this.endTime).format("Y-MM-dd hh:mm:ss"):"",
          companyId: this.userInfo.companyId,
          pageSize: val,
          pageNum: this.currentPage,
          bizCodes: this.bizCodes
        }
        this.getVisitorsList(data)
      },
      /*切换访客列表当前页*/
      currentChange(val) {
        this.currentPage = val
        let data = {
          queryStartTime : Util.isNotEmpty(this.startTime)?new Date(this.startTime).format("Y-MM-dd hh:mm:ss"):"",
          queryEndTime: Util.isNotEmpty(this.endTime)?new Date(this.endTime).format("Y-MM-dd hh:mm:ss"):"",
          companyId: this.userInfo.companyId,
          pageNum: val,
          pageSize: this.pageSize,
          bizCodes: this.bizCodes
        }
        this.getVisitorsList(data)
      },
      /*刷选访客列表*/
      searchVisitorsList() {
        let data = {
          companyId: this.userInfo.companyId,
          pageNum: 0,
          pageSize: this.pageSize,
          bizCodes: this.bizCodes,
          queryStartTime: Util.isNotEmpty(this.startTime) ? new Date(this.startTime).format('Y-MM-dd hh:mm:ss') : '',
          queryEndTime: Util.isNotEmpty(this.endTime) ? new Date(this.endTime).format('Y-MM-dd hh:mm:ss') : ''
        }
        this.getVisitorsList(data)
      },
      /*重置*/
      resetRule() {
        this.startTime = ''
        this.endTime = ''
        this.currentPage = 0
        this.initVisitorsList()
      }
    },
    mounted() {
      this.initBusinessGroup();
      this.initVisitorsList()
    }
  }
</script>
